import { Grid, MenuItem, Select, useTheme } from '@mui/material';
import { formatTimeInput, convertAMPM } from './timeUtils';

const TimeInputSection = ({ inputValue, selectedOption, onInputChange, onOptionChange, condition }) => {
  const theme = useTheme();
  const HeadingColor = theme.palette.blue[700];

  const handleTimeInput = (e) => {
    const raw = e.target.value.replace(/\D/g, '');
  
    if (raw.length === 0) {
      onInputChange('');
      return;
    }
  
    if (raw.length < 3) {
      // just type as-is (max 2 digits = hour only)
      onInputChange(raw);
      return;
    }
  
    const formatted = formatTimeInput(raw);
    const [hh] = formatted.split(':');
    const ampm = parseInt(hh, 10) >= 12 ? 'ب.ظ' : 'ق.ظ';
  
    onInputChange(formatted);
    onOptionChange(ampm);
  };
  

  const handleSelectChange = (e) => {
    const newOption = e.target.value;
    const convertedTime = convertAMPM(inputValue, newOption);
    onOptionChange(newOption);
    onInputChange(convertedTime);
  };

  return (
    <Grid pb="4px" display="flex" alignItems="center" justifyContent="flex-start">
      <input
        placeholder="HH : MM"
        value={inputValue}
        onChange={handleTimeInput}
        readOnly={condition}
        style={{
          border: '1px solid #b8bdc9',
          borderRadius: '3px',
          padding: '10px',
          width: '100%',
          maxWidth: '86px',
          height: '40px',
          fontSize: '12px',
          fontWeight: 700,
          color: HeadingColor,
          marginBottom: '8px',
        }}
      />
      <Grid position="relative">
        <Select
          disabled={condition}
          value={selectedOption}
          onChange={handleSelectChange}
          style={{
            borderRadius: '3px',
            maxWidth: '80px',
            height: '40px',
            fontSize: '12px',
            fontWeight: 700,
            marginBottom: '8px',
          }}
        >
          <MenuItem value="ق.ظ">ق.ظ</MenuItem>
          <MenuItem value="ب.ظ">ب.ظ</MenuItem>
        </Select>
      </Grid>
    </Grid>
  );
};

export default TimeInputSection;
